module.exports = __webpack_public_path__ + "static/img/Jiawen_ZHAO.cf8cef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Jiawen_ZHAO.png
// module id = OdFv
// module chunks = 1